export function isValidEstablishment(
  place: google.maps.places.PlaceResult
): boolean {
  if (!place.types) {
    return false;
  }

  const types = place.types;
  const geographicArea =
    types.includes("neighborhood") ||
    types.includes("postal_code") ||
    types.includes("postal_town") ||
    types.includes("vicinity") ||
    types.includes("locality") ||
    types.includes("political");

  return !geographicArea;
}
